import { useQuery } from 'react-query';

import getWorksite from '@/common/api/worksites/getWorksite';
import { ENDPOINT_WORKSITES } from '@/common/constants';

const useWorksite = (id, keepPreviousData = true) =>
  useQuery([ENDPOINT_WORKSITES, id], getWorksite, {
    enabled: !!id,
    keepPreviousData,
  });

export default useWorksite;
